import React, { useState } from 'react';
import { Details } from '../../../components';

const DefaultPanel = ({ heading, items }) => {
  const [open, setOpen] = useState(true);

  return (
    <Details
      open
      onClick={() => {setOpen(!open)}}
      summary={heading}
    >
      {items.map((item, index) => {
        return (
          <p>
            <span className="panel_default-heading">{item.name}</span>: <span>{item.value}</span>
          </p>
        )
      })}
    </Details>
  );
}

export default DefaultPanel;